export default __webpack_public_path__ + "static/media/money-going.fab9fa59.svg";